// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dot-9-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.152 2.232c0 .576.504 1.08 1.08 1.08s1.08-.504 1.08-1.08-.504-1.08-1.08-1.08-1.08.504-1.08 1.08zm6.768 0c0 .576.504 1.08 1.08 1.08s1.08-.504 1.08-1.08-.504-1.08-1.08-1.08-1.08.504-1.08 1.08zm6.696 0c0 .576.504 1.08 1.08 1.08s1.08-.504 1.08-1.08-.504-1.08-1.08-1.08-1.08.504-1.08 1.08zM1.152 9c0 .576.504 1.08 1.08 1.08s1.08-.504 1.08-1.08-.504-1.08-1.08-1.08-1.08.504-1.08 1.08zM7.92 9c0 .576.504 1.08 1.08 1.08s1.08-.504 1.08-1.08S9.576 7.92 9 7.92 7.92 8.424 7.92 9zm6.696 0c0 .576.504 1.08 1.08 1.08s1.08-.504 1.08-1.08-.504-1.08-1.08-1.08-1.08.504-1.08 1.08zM1.152 15.768c0 .576.504 1.08 1.08 1.08s1.08-.504 1.08-1.08-.504-1.08-1.08-1.08-1.08.504-1.08 1.08zm6.768 0c0 .576.504 1.08 1.08 1.08s1.08-.504 1.08-1.08-.504-1.08-1.08-1.08-1.08.504-1.08 1.08zm6.696 0c0 .576.504 1.08 1.08 1.08s1.08-.504 1.08-1.08-.504-1.08-1.08-1.08c-.576-.072-1.08.504-1.08 1.08z'
  />
);

export const viewBox = '0 0 18 18';
